import { customerv6Url_NPF } from '../api-urls';

export function createSendEmailRequest(email, event) {
  return {
    url: `${customerv6Url_NPF}/fast-registry/actions/send-email`,
    method: 'POST',
    timeout: 2500,
    data: {
      email,
      event
    }
  };
}
